import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Div, Panel, Typography } from '@icecreamsocial/components';
import { useStore } from '../../../../../../../../../utils/hooks';
import OfferSettingsForm from '../../../../../../components/OfferSettingsForm';
import { Link } from 'react-router-dom';
import {
	NoProcessorPanel,
	EditFormControls,
	Pagename,
} from '../../../../../../../../presentational';
import { formatImageURL } from '../../../../../../../../../utils';
import { useCampaign } from '../../../../providers/Campaign';

const OfferSettings = () => {
	const store = useStore();
	const { campaign, update } = useCampaign();
	const { data } = campaign;

	const initialValues = {
		giftCardAmount: data?.giftCardAmount,
		conversionGoal: data?.conversionGoal,
		offerHeading: data?.offerHeading,
		offerInstructions: data?.offerInstructions,
		offerImageCaption: data?.offerImageCaption,
		offerImageTitle: data?.offerImageTitle,
		offerImage: formatImageURL(data?.offerImage),
		refundAmount: data?.refundAmount,
		thankYouImage: formatImageURL(data?.thankYouImage),
	};
	const isSquare = useMemo(
		() => store.userProcessorType?.toLowerCase().indexOf('square') > -1,
		[store.userProcessorType]
	);

	const hasProcessor = useMemo(() => !!store.userProcessorType, [
		store.userProcessorType,
	]);

	const onSubmit = async ({ ...values }) => {
		const toSubmit = { ...values };
		if (parseInt(values.refundAmount) === 0) {
			toSubmit.useCardFlexRefund = false;
		}
		return update.mutate({
			...toSubmit,
		});
	};

	return (
		<>
			{!store.userProcessorType && <NoProcessorPanel />}
			<Pagename>Offer Settings</Pagename>
			<Typography.P>
				Describe your offer to the person sharing it. We've provided some
				default copy that we've seen perform best. Customize it and make it your
				own to fit your campaign needs.
			</Typography.P>
			{data && (
				<OfferSettingsForm
					onSubmit={onSubmit}
					isSquare={isSquare}
					hasProcessor={hasProcessor}
					renderControls={(props) => <EditFormControls {...props} />}
					{...initialValues}
				/>
			)}
		</>
	);
};
OfferSettings.displayName = 'OfferSettingsForm';

export default observer(OfferSettings);
